import { Lightning } from '@lightningjs/sdk';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  handle: makeThemeColor(PRIMARY),
};

// NOTE: diameter must be lower for 2 px than in abstract due to issue https://github.com/rdkcentral/Lightning/issues/224#issue-685623103
export const DIAMETER = {
  [HD]: 22,
  [FULL_HD]: 30,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const size = DIAMETER[screenSize];

  return {
    color: colors.handle[colorMode],
    texture: Lightning.Tools.getRoundRect(
      size,
      size,
      Math.round(size / 2),
      0,
      0x00000000,
      true,
      colors.handle[colorMode],
    ),
  };
};
